import { Box, Card, Stack, SxProps, Theme, Typography } from '@mui/material'

import { t } from 'i18next'

import responsiveHook from '@hooks/useResponsive'

import { scaleUpTransition } from '@utils/styles'

import {
  NMSDCCertificationImageSx,
  certificationsWrapperSx,
  genericCertificationCardSx,
  genericCertificationImageSx,
  theIncCertificationCardSx,
  theIncCertificationImageSx,
  theIncCertificationTextSx,
  womanOfTheYearCertificationCardSx,
  womanOfTheYearCertificationImageSx,
} from './styles'

interface ICertificationCardsProps {
  containerSx?: SxProps<Theme>
}

const CertificationCards = ({
  containerSx: overrideContainerSx,
}: ICertificationCardsProps) => {
  const { isMobile, ifDesktop } = responsiveHook.useResponsive()

  const womanOfTheYearCertificationImagePath = isMobile
    ? '/images/certifications/enterprising-woman-of-the-year-certification-mobile.png'
    : '/images/certifications/enterprising-woman-of-the-year-certification.png'

  return (
    <Stack
      direction="row"
      sx={
        { ...certificationsWrapperSx, ...overrideContainerSx } as SxProps<Theme>
      }
    >
      <Card
        title={t('Ranked #123 on the Inc 5000 List!')}
        elevation={3}
        sx={{
          ...theIncCertificationCardSx,
          ...ifDesktop(scaleUpTransition),
        }}
      >
        <Box
          alt={t('Ranked #123 on the Inc 5000 List!')}
          loading="lazy"
          component="img"
          src="/images/certifications/the-inc-certification.png"
          sx={theIncCertificationImageSx}
        />
        {!isMobile && (
          <Typography variant="subtitle1" sx={theIncCertificationTextSx}>
            {t(`Ranked #123 on\nthe Inc 5000 List!`)}
          </Typography>
        )}
      </Card>

      <Card
        title={t('Winner of 2024 Enterprising Woman of The Year')}
        elevation={3}
        sx={{
          ...womanOfTheYearCertificationCardSx,
          ...ifDesktop(scaleUpTransition),
        }}
      >
        <Box
          alt={t('Winner of 2024 Enterprising Woman of The Year')}
          loading="lazy"
          component="img"
          src={womanOfTheYearCertificationImagePath}
          sx={womanOfTheYearCertificationImageSx}
        />
      </Card>

      <Card
        elevation={3}
        title={t("Certified WBENC Women's Business Enterprise")}
        sx={{
          ...genericCertificationCardSx,
          ...ifDesktop(scaleUpTransition),
        }}
      >
        <Box
          alt={t("Certified WBENC Women's Business Enterprise")}
          loading="lazy"
          component="img"
          src="/images/certifications/wbenc-certification.png"
          sx={genericCertificationImageSx}
        />
      </Card>

      <Card
        title={t('Certified NMSDC MBE 2022')}
        elevation={3}
        sx={{
          ...genericCertificationCardSx,
          ...ifDesktop(scaleUpTransition),
        }}
      >
        <Box
          alt={t('Certified NMSDC MBE 2022')}
          loading="lazy"
          component="img"
          src="/images/certifications/nmsdc-certification.png"
          sx={NMSDCCertificationImageSx}
        />
      </Card>
    </Stack>
  )
}

export { CertificationCards }
